export enum MetricsNames {
  gasConsumptionReductionPercentage = 'gasConsumptionReductionPercentage',
  electricityConsumptionReductionPercentage = 'electricityConsumptionReductionPercentage',
  costSavingsEur = 'costSavingsEur',
  costSavingsPct = 'costSavingsPct',
  investmentEur = 'investmentEur',
  paybackPeriod = 'paybackPeriod',
}

/** An entry of the `itemsList` name-label list. */
export interface Metric {
  name?: string;
  label?: string;
}
